import { Dialog, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef } from "react";
import { BottomSheetSize } from "./useBottomSheet";

const bottomSheetSizes = {
    [BottomSheetSize.SM]: '400px',
    [BottomSheetSize.MD]: '900px',
    [BottomSheetSize.LG]: '1200px'
}

interface BottomSheetProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    backDrop?: boolean;
    size?: BottomSheetSize;
    closeOnBackdropClick?: boolean;
}

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },  
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const BottomSheet: React.FC<BottomSheetProps> = ({ open, onClose, children, backDrop = true, size = BottomSheetSize.MD, closeOnBackdropClick = true }) => {

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'backdropClick' && !closeOnBackdropClick) {
            return;
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullScreen
            hideBackdrop={!backDrop}
            disableEscapeKeyDown={!closeOnBackdropClick}
            sx={{
                '& .MuiDialog-paper': {
                    margin: 0,
                    borderRadius: '8px 8px 0 0',
                    maxHeight: '90vh',
                    maxWidth: bottomSheetSizes[size],
                    minHeight: '60vh',
                    alignSelf: 'flex-end',
                }
            }}
        >
            {children}
        </Dialog>
    );
};  